<template>
  <div>
    {{ shouldStop }} {{ stopped }} {{ recording }}
    <a id="download" :href="href" :download="download">Download</a>
    <button @click.prevent="start" :disabled="recording" id="start">Start</button>
    <button @click.prevent="stop"  :disabled="!recording" id="stop">Stop</button>
  </div>
</template>

<script>
// Safari support - https://github.com/ai/audio-recorder-polyfill
import AudioRecorder from 'audio-recorder-polyfill'
export default {
  data() {
    return {
      shouldStop: false,
      stopped: true,
      recording: false,
      href: null,
      download: null,
      recordedChunks: [],
      mediaRecorder: null
    };
  },
  created() {
    console.log('created')
    if (typeof MediaRecorder === 'undefined') {
        console.log('MediaRecorder not supported, using polyfill')
        window.MediaRecorder = AudioRecorder
    }
    navigator.mediaDevices
      .getUserMedia({ audio: true, video: false })
      .then(this.handleSuccess)
  },
  destroyed() {
    this.mediaRecorder.stop()
    this.mediaRecorder.onstop = null
    this.mediaRecorder.ondataavailable = null
    this.stopped = true
  },
  methods: {
    start() {
      this.recordedChunks = []
      this.recording = true
      this.stopped = false
      this.shouldStop = false
      this.mediaRecorder.start(1000);
    },
    stop() {
      this.shouldStop = true;
    },
    dataAvailable(e) {
      console.log("processed chunk", this.shouldStop, this.stopped);
      if (e.data.size > 0) {
        this.recordedChunks.push(e.data);
      }

      if (this.shouldStop === true && this.stopped === false) {
        this.mediaRecorder.stop();
        this.stopped = true;
        this.recording = false
      }
    },
    recorderStop() {
      console.log("audio recorder - stop");
      this.href = URL.createObjectURL(new Blob(this.recordedChunks));
      this.download = "acetest.wav";
    },
    handleSuccess(stream) {
      console.log("audio recorder - handling success");
      const options = { mimeType: "audio/webm" };
      this.mediaRecorder = new MediaRecorder(stream, options);

      this.mediaRecorder.ondataavailable = this.dataAvailable;

      this.mediaRecorder.onstop = this.recorderStop;

    //   this.mediaRecorder.start(1000);
    }
  }
};
</script>